/**
 * Component constants file
 * 
 * This file exports all constants that are shared by multiple components.
 * These constants are generally related to glueing together the legacy system to this one.
 */

// url to use when navigating to older pages
export const LEGACY_URL = process.env.NODE_ENV === "production" ? "" : "//localhost";

// fallback images
export const DEFAULT_PROFILE = '/mobile/reg/images/profile-photo-default.jpg';
export const DEFAULT_LOGO = '/schoolLogos/logo.png';
export const DEFAULT_PRIZE = '/v2/images/imgsrepo/default.png';

// School 9 (Oholei Torah) uses a separate print host in production
export const V_MASHPIA_PRINT_SCHOOL_ID = 9;
export const V_MASHPIA_PRINT_URL = 'https://v.mashpia.com/api/print/missions';

// Serial number format used for quick-select soldier lookup
export const SERIAL_NUMBER_REGEX = /^77[0-9]{5}$/;      // JS logic match
export const SERIAL_NUMBER_PATTERN = '77[0-9]{5}';       // HTML input pattern attribute (browser validation)

// api keys
export const GOOGLE_CLIENT_ID = '356394568289-o9uqieb96qevc8a1plmm5voa6so0l2fd.apps.googleusercontent.com';
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibmFmdG9saXIiLCJhIjoiY2xsZTR5NHFuMDBzeTNzdWxqcnd1ZGJ0ZSJ9.7M6yPlYYDHRE-QcRUp_z9A';


// WEBPACK FOOTER //
// ./src/components/constants.js